import { useDeleteWithdrawal, useLogout } from 'Shared/hooks/api';
import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { Button, CheckFill, Column, Icon, Row, Typography } from '@viewup/ui';
import dayjs from 'dayjs';
import jwtDecode from 'jwt-decode';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

export const CancelWithdrawal = () => {
  const router = useRouter();
  const { accessToken } = useTokenStore();
  const [withdrawalAt, setWithdrawalAt] = useState<string | undefined>();
  const { logout } = useLogout({
    options: {
      onSuccess: () => {
        window.location.reload();
      },
    },
  });
  const { mutateAsync: cancelWithdrawal } = useDeleteWithdrawal({
    options: {
      onSuccess: () => {
        window.location.reload();
      },
    },
  });

  useEffect(() => {
    const withdrawalTime =
      (accessToken && jwtDecode<{ withdrewAt: number }>(accessToken).withdrewAt) || '';

    if (!accessToken || !withdrawalTime) {
      router.refresh();
      return;
    }

    setWithdrawalAt(dayjs(withdrawalTime).format('YY.MM.DD'));
  }, [accessToken, router]);

  const handleClickCancelWithdrawal = () => {
    cancelWithdrawal({});
  };

  return (
    <Column alignItems='center' height={'100vh'} justifyContent='center' p={24} width={'100%'}>
      <Column alignItems='center' gap={16} justifyContent='center' width={'100%'}>
        <Icon color='icon.info' size='S' source={CheckFill} />
        <Column alignItems='center' gap={8}>
          <Typography fontType='body.bold'>회원 탈퇴 신청이 완료되었어요.</Typography>
          <Typography
            css={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}
            fontType='body2.regular'
          >
            {`해당 아이디는 탈퇴 신청 시점으로부터\n3일 후 영구 삭제될 예정이에요.`}
          </Typography>
        </Column>

        <Row bgColor='bg.secondary' br={8} justifyContent='space-between' p={12} width={'100%'}>
          <Typography color='text.tertiary' fontType='body2.regular'>
            탈퇴 예정일
          </Typography>

          <Typography color='text.info' fontType='body2.regular'>
            {withdrawalAt}
          </Typography>
        </Row>

        <Row gap={8} width={'100%'}>
          <Button
            css={{ width: '100%' }}
            onClick={handleClickCancelWithdrawal}
            size='L'
            variant='outline.assistive'
          >
            신청취소
          </Button>
          <Button
            css={{ width: '100%' }}
            onClick={() => logout({})}
            size='L'
            variant='solid.primary'
          >
            로그아웃
          </Button>
        </Row>
      </Column>
    </Column>
  );
};
